__turbopack_context__.v({
  "blogCardsContainer": "Kqz35G_blogCardsContainer",
  "emptyBlogCard": "Kqz35G_emptyBlogCard",
  "newsContainer": "Kqz35G_newsContainer",
  "newsHeading": "Kqz35G_newsHeading",
  "readMoreIconLeft": "Kqz35G_readMoreIconLeft",
  "readMoreIconRight": "Kqz35G_readMoreIconRight",
  "visible": "Kqz35G_visible",
});
